module.exports = __webpack_public_path__ + "ad4ca71915f2235d2973f293d8c0b461.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_40.jpg
// module id = 1746
// module chunks = 5